import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { login as apiLogin, fetchMe } from "../lib/api";

const AuthContext = createContext(null);
const TOKEN_KEY = "modesto_admin_token";

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
  const [user, setUser] = useState(null); // null=checking, false=none, obj=auth
  const [loading, setLoading] = useState(true);

  const verify = useCallback(async (t) => {
    if (!t) {
      setUser(false);
      setLoading(false);
      return;
    }
    try {
      const me = await fetchMe(t);
      setUser(me);
    } catch (e) {
      localStorage.removeItem(TOKEN_KEY);
      setToken(null);
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    verify(localStorage.getItem(TOKEN_KEY));
  }, [verify]);

  const signIn = async (email, password) => {
    const data = await apiLogin(email, password);
    localStorage.setItem(TOKEN_KEY, data.token);
    setToken(data.token);
    setUser({ email: data.email, role: "admin" });
    return data;
  };

  const signOut = () => {
    localStorage.removeItem(TOKEN_KEY);
    setToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ token, user, loading, signIn, signOut }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
